import {useQuery, useQueryClient} from '@tanstack/react-query';
import {fetchRecords} from '../services/ReportTypesService';
import {useState} from 'react';
import {ReportType} from '../types';

export const useReportTypes = () => {
    const queryClient = useQueryClient();
    const [keyword, setKeyword] = useState('');

    const reportTypesQuery = useQuery({
        queryKey: ['reportTypes'],
        queryFn: () => fetchRecords(),
    });

    const fetchRecordsAction = () => {
        queryClient.invalidateQueries({queryKey: ['reportTypes']});
    };

    const handleFilterByKeyword = (newKeyword: string) => {
        setKeyword(newKeyword);
    };

    const allItems: ReportType[] = reportTypesQuery.data?.items || [];

    const visibleItems = keyword
        ? allItems.filter(item => {
            const search = keyword.toLowerCase();
            return (
                item.id?.toLowerCase().includes(search) ||
                item.name?.toLowerCase().includes(search)
            );
        })
        : allItems;

    return {
        items: allItems,
        visibleItems,
        loading: reportTypesQuery.isLoading,
        keyword,
        visibleCount: visibleItems.length,
        totalCount: allItems.length,
        fetchRecords: fetchRecordsAction,
        handleFilterByKeyword,
    };
};
